module.exports = __webpack_public_path__ + "static/media/bellesiniacademy.03d568c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/bellesiniacademy.jpg
// module id = 639
// module chunks = 0